import axios, { AxiosResponse } from 'axios';

export interface IClaimApi {
  claimTransmit(step: any): Promise<AxiosResponse<string>>;
  benefitManagement(params: any, claimNumber: string): Promise<AxiosResponse<any>>;
  terminateClaim(globalData: any, claimNumber: string, benefitId: string): Promise<AxiosResponse<any>>;
  detectRefusal(step: any): Promise<AxiosResponse<any>>;
  getClaim(claimNumber: any): Promise<AxiosResponse<any>>;
  getClaimProductCode(idSubscription: any): Promise<AxiosResponse<any>>;
  updateClaimDetails(claimDetailsDto: any): Promise<AxiosResponse<any>>;
  createBenefitTask(claimId: any, data: any): Promise<AxiosResponse<any>>;
}

class ClaimApi implements IClaimApi {
  async claimTransmit(params: any): Promise<AxiosResponse<string>> {
    return await axios.put('/api/claim-transmit', params);
  }

  async benefitManagement(params: any, claimNumber: string): Promise<AxiosResponse<any>> {
    return await axios.put('/api/claim/' + claimNumber + "/benefit-management", params);
  }

  async terminateClaim(globalData: any, claimNumber: string, benefitId: string ): Promise<AxiosResponse<any>> {
  return await axios.put('/api/claim/'+ claimNumber+'/terminate', globalData);
  
 }

 
  async createBenefitTask(claimNumber: any, data:any): Promise<AxiosResponse<any>> {
    return await axios.put('/api/claim/'+ claimNumber + "/create-task" ,data);
}
  async detectRefusal(params: any): Promise<AxiosResponse<any>> {
    return await axios.post('/api/detect-refusal', params);
  }

  async getClaim(claimNumber): Promise<AxiosResponse<any>> {
    return await axios.get(`/api/claim/${claimNumber}`);
  }

  async updateClaimDetails(claimDetailsDto: any): Promise<AxiosResponse<any>> {
    return await axios.post('/api/updateClaimDetails', claimDetailsDto);
  }
  async saveClaimErrorLog(data: any): Promise<AxiosResponse<any>> {
    return await axios.post('/api/saveClaimErrorLog', data);
  }

  async getClaimProductCode(idSubscription: any): Promise<AxiosResponse<any>> {
    return await axios.get(`/api/claimProductCode/${idSubscription}`);
  }

}

const claimApi = new ClaimApi();

export { claimApi };
